import { defineComponent } from 'vue'
import type { DialogServiceMethods } from 'primevue/dialogservice'
import Button from 'primevue/button'
import { promptScheduleWalkthrough } from '@/components/schedule-walkthrough-dialog'
import { TOUR_COMPLETION } from '@/components/tour/console-tour-steps'
import '@/components/support-dialog.css'
import '@/components/tour/console-tour.css'

/**
 * Closes out the console tour.
 *
 * Two jobs, both about what happens after the overlay disappears. It says how to get the tour
 * back, because a one-time tour people cannot re-open is a tour they have to remember perfectly
 * the first time. And it offers a live walkthrough, because six popovers do not fix everyone --
 * the people still lost at the end are exactly the ones worth putting in front of a human before
 * they give up and switch back to Classic.
 */
export function showConsoleTourCompletion (dialog: DialogServiceMethods): void {
  const DialogContent = defineComponent({
    setup () {
      return () => (
        <div class="support-dialog console-tour-completion">
          <div class="feedback-step feedback-step-narrow">
            <div class="tw:text-base tw:font-semibold tw:mb-2">{TOUR_COMPLETION.title}</div>
            <div class="tw:text-sm tw:mb-4">{TOUR_COMPLETION.body}</div>

            <div class="tw:flex tw:justify-end tw:gap-2">
              <Button
                type="button"
                size="small"
                severity="secondary"
                label={TOUR_COMPLETION.book}
                onClick={() => {
                  dialogRef.close()
                  promptScheduleWalkthrough(dialog)
                }}
              />
              <Button
                type="button"
                size="small"
                label={TOUR_COMPLETION.finish}
                onClick={() => dialogRef.close()}
              />
            </div>
          </div>
        </div>
      )
    }
  })

  const dialogRef = dialog.open(DialogContent, {
    props: {
      header: TOUR_COMPLETION.header,
      pt: {
        root: 'support-dialog-shell tw:!overflow-hidden tw:!rounded-xl'
      },
      modal: true,
      closable: true,
      dismissableMask: true,
      closeOnEscape: true
    }
  })
}
